// TODO: remove this dirty shims when all major browsers start support it
// or replace them with adult library/shim like System.js or Require.js
window.Promise =	window.Promise
	|| (function () {

		function reject (reason) {

			const d = jQuery.Deferred();
			let p;
			p = d.reject(reason).promise();
			return wrap(p, d, p.then, p.fail);

		}

		function resolve (arg) {

			const d = jQuery.Deferred();
			let p;
			p = d.resolve(arg).promise();
			return wrap(p, d, p.then, p.fail);

		}

		function all (promises) {

			const deferreds = [];
			promises.forEach((p) => {

				deferreds.push(p.d);

			});
			return jQuery.when.apply(jQuery, deferreds);

		}

		function wrap (p, d, t, c) {

			p.d = d;
			p.then = methodWrp(t);
			p.catch = methodWrp(c);
			return p;

		}

		function methodWrp (method) {

			return function (a, b) {

				const p = method(a, b);
				if (p.d) {

					return p;

				}
				return wrap(p, this.d, p.then, p.fail);

			};

		}

		function P (callBack) {

			const d = jQuery.Deferred();
			let p;
			callBack(d.resolve, d.reject);
			p = d.promise();
			return wrap(p, d, p.then, p.fail);

		}

		P.reject = reject;
		P.resolve = resolve;
		P.all = all;

		return P;

	}());

window.System = window.System || {
	import (moduleName) {

		return new Promise((resolve, reject) => {

			const el = document.createElement('script');

			if (el.addEventListener) {

				el.onload = resolve;

			} else if (el.readyState) {

				el.onreadystatechange = resolve;

			}

			el.onerror = reject;
			el.async = true;
			el.src = this.opt.baseURL + moduleName + this.opt.fileExt;
			document.getElementsByTagName('body')[0].appendChild(el);

		});

	},
	opt: { baseURL: './', fileExt: '.js' },
	config (opt = {}) {

		for (const prop in opt) {

			this.opt[prop] = opt[prop];

		}
		return this;

	}
};
